// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__2p_fd","sendOtp":"AuthorizeToLogin_sendOtp__2nd8n"};